function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import CustomerDialogue from "../customer-dialogue/CustomerDialogue";
const CustomerTranslatableDialogue = ({
  dialogue,
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  const translatedContent = t(dialogue.body);
  return /*#__PURE__*/React.createElement(CustomerDialogue, _extends({
    dialogue: {
      ...dialogue,
      body: translatedContent
    }
  }, rest));
};
export default CustomerTranslatableDialogue;
CustomerTranslatableDialogue.propTypes = {
  dialogue: PropTypes.object.isRequired
};